import { MediaMatch } from '@lamimed/pantheon';

import { useCategory } from 'hooks/useCategory';

import ThumbnailDivider from 'components/ThumbnailDivider';

import { Step } from './Step';
import { StepsCarousel } from './StepsCarousel';

import * as S from './styles';

export const HowItWorks: React.FC = () => {
  const { categoryData } = useCategory();

  return (
    <>
      <ThumbnailDivider
        title="Come funziona"
        description="Scopri come è semplice prenotare, bastano pochi minuti."
        image="/images/illustration/come-funziona.png"
      />

      <S.Wrapper>
        <MediaMatch lessThan="tablet">
          {categoryData?.howItWorks.map((step, index) => (
            <Step
              key={step.title}
              title={step.title}
              description={step.description}
              stepNumber={index + 1}
            />
          ))}
        </MediaMatch>

        <MediaMatch greaterThan="tablet">
          <StepsCarousel />
        </MediaMatch>
      </S.Wrapper>
    </>
  );
};
